import styled, { css } from 'styled-components';
import { theme } from '../themes';

const Styles = css`

     .ruboalastras .body-wrapper{
          background-color: #eee;
          padding:0px !important;
          > div{
               max-width: 100%;
               margin:0px;
          }
     }
`

export default Styles
